<template>
  <div>
    <h4 class="header" v-html="data.text"></h4>
    <button class="ui green button" @click="openLink">{{ buttonText }}</button>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'WebLink',
  props: ['id', 'type', 'data', 'standard'],
  computed: {
    buttonText() {
      return this.data.button_text ? this.data.button_text : 'Visit Link';
    },
  },
  methods: {
    openLink() {
      window.open(this.data.url, '_blank');
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction();
      }
    },
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: true,
        answer: 'opened',
        description: this.data.text,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
  },
};
</script>
